import { render, staticRenderFns } from "./no_people.vue?vue&type=template&id=bc39243c&scoped=true"
import script from "./no_people.vue?vue&type=script&lang=js"
export * from "./no_people.vue?vue&type=script&lang=js"
import style0 from "./no_people.vue?vue&type=style&index=0&id=bc39243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39243c",
  null
  
)

export default component.exports